export enum SystemModuleType {
    DefineWorkflowInput = 'DefineWorkflowInput',
    DefineModuleInput = 'DefineModuleInput',
}
